import app from '@/app'
import {Container, Application} from "pixi.js";
import BackgroundView from "@/app/pixi/views/BackgroundView";
import Loader from "@/app/utils/pixi/Loader";
import "gsap/PixiPlugin";

import CHAPTERS_DATA from 'assets/data/chapters';

export default class PixiApp {

    /**
     *
     * @type {Loader}
     */
    static loader = new Loader();

    constructor() {
        /**
         *
         * @type {Application}
         */
        this.pixiApp = null;

        /**
         *
         * @type {Container}
         */
        this.mainContainer = null;
        this.addAssetsToLoader();
    }

    async setup() {
        const pixiApp = new Application({
            autoResize: true,
            width: window.innerWidth,
            height: window.innerHeight,
            resolution: 1,
            transparent: true,
            antialias: true,
            roundPixels: true,
        });

        this.pixiApp = pixiApp;
        this.mainContainer = new Container();
        this.mainContainer.name = "mainContainer";
    };

    addAssetsToLoader() {
        CHAPTERS_DATA.forEach((chapter) => {
            PixiApp.loader.addImage(chapter.videoCover);
        })
    };

    init($el) {
        this.backgroundView = new BackgroundView();
        this.mainContainer.addChild(this.backgroundView);
        this.pixiApp.stage.addChild(this.mainContainer);
        $el.appendChild(this.pixiApp.view);
        this.initListeners()
    }

    initListeners() {
        app.resize.add(this.resized, this);
    }

    resized({width, height}) {
        const {renderer} = this.pixiApp;
        renderer.view.style.width = `${width}px`;
        renderer.view.style.height = `${height}px`;
        renderer.autoResize = true;
        renderer.resize(width, height);
    }

    destroy() {
        app.resize.remove(this.resized, this);
        this.pixiApp.destroy(true, {children: true});
    }
}



// WEBPACK FOOTER //
// ./src/app/pixi/PixiApp.js